export const DashboardConstants = {
  USER_DASHBOARD_COUNT_REQUEST: "USER_DASHBOARD_COUNT_REQUEST",
  USER_DASHBOARD_COUNT_SUCCESS: "USER_DASHBOARD_COUNT_SUCCESS",
  USER_DASHBOARD_COUNT_FAILURE: "USER_DASHBOARD_COUNT_FAILURE",

  REVENUE_CHART_DATA_REQUEST: "REVENUE_CHART_DATA_REQUEST",
  REVENUE_CHART_DATA_SUCCESS: "REVENUE_CHART_DATA_SUCCESS",
  REVENUE_CHART_DATA_FAILURE: "REVENUE_CHART_DATA_FAILURE",

  RENEWAL_CHART_DATA_REQUEST: "RENEWAL_CHART_DATA_REQUEST",
  RENEWAL_CHART_DATA_SUCCESS: "RENEWAL_CHART_DATA_SUCCESS",
  RENEWAL_CHART_DATA_FAILURE: "RENEWAL_CHART_DATA_FAILURE",
};
